import { useMemo } from "react";

function hashHue(str = "") {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h << 5) - h + str.charCodeAt(i);
  return Math.abs(h) % 360;
}

const SIZES = { xs: "w-6 h-6 text-[10px]", sm: "w-8 h-8 text-xs", md: "w-10 h-10 text-sm", lg: "w-16 h-16 text-lg" };

export default function Avatar({ name, picture = "", size = "sm", className = "" }) {
  const safeName = name || "";
  const initials = useMemo(() => {
    const parts = safeName.trim().split(/\s+/).slice(0, 2);
    return parts.map((p) => p[0]?.toUpperCase() || "").join("") || "?";
  }, [safeName]);
  const hue = useMemo(() => hashHue(safeName), [safeName]);

  if (picture) {
    return (
      <img
        src={picture}
        alt={safeName}
        className={`${SIZES[size]} rounded-full object-cover shrink-0 border border-zinc-200 ${className}`}
      />
    );
  }
  return (
    <div
      className={`${SIZES[size]} rounded-full shrink-0 inline-flex items-center justify-center font-semibold ${className}`}
      style={{
        background: `hsl(${hue} 55% 88%)`,
        color: `hsl(${hue} 40% 35%)`,
      }}
      aria-label={safeName}
    >
      {initials}
    </div>
  );
}

/**
 * Resize image file to a square 256x256 JPEG data URL, targeting < ~40KB.
 */
export async function fileToAvatarDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const size = 256;
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext("2d");
        // cover crop
        const scale = Math.max(size / img.width, size / img.height);
        const w = img.width * scale;
        const h = img.height * scale;
        const x = (size - w) / 2;
        const y = (size - h) / 2;
        ctx.drawImage(img, x, y, w, h);
        resolve(canvas.toDataURL("image/jpeg", 0.82));
      };
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
